/** Gap between tab buttons — matches Tailwind `gap-1` on FloatingTabPill. */
export const FLOATING_TAB_PILL_GAP_PX = 4

/** Horizontal padding inside the pill — matches Tailwind `p-0.5` × 2. */
export const FLOATING_TAB_PILL_PAD_X_PX = 4

export type FloatingTabLabelCollapseTab = {
  id: string
  labeledWidth: number
  iconOnlyWidth: number
  labelCollapsible: boolean
}

/**
 * Which tab ids should hide their label so the row fits `availableWidth`
 * (full pill outer width including pad). Collapses right-to-left among
 * `labelCollapsible` tabs only; others always keep labeled width.
 */
export function floatingTabIdsWithHiddenLabels(
  tabs: readonly FloatingTabLabelCollapseTab[],
  availableWidth: number,
  gapPx: number = FLOATING_TAB_PILL_GAP_PX,
  padXPx: number = FLOATING_TAB_PILL_PAD_X_PX,
): ReadonlySet<string> {
  if (tabs.length === 0) return new Set()

  const widths = tabs.map((tab) => tab.labeledWidth)
  const hidden = new Set<string>()

  const total = () => {
    const gaps = tabs.length > 1 ? gapPx * (tabs.length - 1) : 0
    return padXPx + widths.reduce((sum, w) => sum + w, 0) + gaps
  }

  while (total() > availableWidth) {
    let collapseAt = -1
    for (let i = tabs.length - 1; i >= 0; i -= 1) {
      const tab = tabs[i]!
      if (tab.labelCollapsible && !hidden.has(tab.id)) {
        collapseAt = i
        break
      }
    }
    if (collapseAt < 0) break
    const tab = tabs[collapseAt]!
    hidden.add(tab.id)
    widths[collapseAt] = tab.iconOnlyWidth
  }

  return hidden
}
